'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.explore__title {\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 700;\n  margin: calc(0.75 * 1rem) 0;\n}\n.explore__description {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n}\n.explore__lists {\n  display: flex;\n  flex-direction: column;\n}\n.explore__link {\n  padding: calc(0.75 * 1rem) 0;\n  border-bottom: 1px solid #dfdfdf;\n  color: #1D66DD;\n  white-space: nowrap;\n  overflow: scroll;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}");
//# sourceMappingURL=Explore.scss.js.map
